import { render } from "./SubBundlesBody.vue?vue&type=template&id=3462126c"
import script from "./SubBundlesBody.vue?vue&type=script&lang=js"
export * from "./SubBundlesBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__